export default () => ({
    entities: {},
})
